<template>
  <div class="print-results">
    <el-table class="table-striped wrap-whole-words" id="projectSearchResults"
              :data="tableData"
              border
              style="width: 100%">
      <el-table-column v-for="column in tableColumns"
                       :key="column.label"
                       :min-width="column.minWidth"
                       :prop="column.prop"
                       :sortable="column.sortable"
                       :label="column.label">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { Table, TableColumn } from 'element-ui'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      Table,
      TableColumn
    },
    computed: {
      ...mapGetters({
        tableData: 'projects/search/results'
      })
    },
    data() {
      return {
        tableColumns: [
          {
            prop: '_source.name',
            label: 'Name',
            minWidth: 110,
            sortable: true
          },
          {
            prop: '_source.number',
            label: 'Number',
            minWidth: 110,
            sortable: true
          },
          {
            prop: '_source.projectType',
            label: 'Type',
            minWidth: 100,
            sortable: true
          },
          {
            prop: '_source.address.city',
            label: 'City',
            minWidth: 100,
            sortable: true
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>
